module.exports = __webpack_public_path__ + "media/assets/images/lib/content-tools/ce-drop-left-a397e1c924397f391ff541daec26dbc0.png";